import { Component, Optional } from '@angular/core';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';
import { DynamicFormService } from '@ntap/common';
import {
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  ItemActionResult,
  ItemUtil,
  ItemView,
  ItemViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  NtapGlobalConstants,
  Util,
  ViewResult,
  ViewResultListener,
  ViewState,
  ViewWindow,
  ViewWindowComponent,
  WindowRegistry
} from '@ntap/core';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { filter, first, map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-open-generator-urbroj-action',
  templateUrl: './open-generator-urbroj-action.component.html',
  providers: [
    {
      provide: ViewResultListener,
      useExisting: ViewWindowComponent
    },
    {
      provide: WindowRegistry,
      useClass: WindowRegistry
    },
    {
      provide: DynamicFormService,
      useClass: DynamicFormService
    }
  ]
})
export class OpenGeneratorUrbrojActionComponent extends PrimeNGButtonNewItemViewActionComponent {
  static GENERATOR_URBROJ_VIEW_TARGET = 'generator_urbroj_dialog';

  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    @Optional() protected listViewProvider: ListViewProviderDirective<ListView>,
    @Optional() protected itemViewProvider: ItemViewProviderDirective<ItemView>
  ) {
    super(notificationService, windowRegistry, window, listViewProvider);
  }

  protected override doExecuteWithItem(): Observable<ItemActionResult> {
    const item$ = this.itemViewProvider?.item$ ?? this.itemProvider.item$;
    return item$.pipe(
      first(),
      switchMap((currentItem: any) => {
        const keyItem: any = ItemUtil.extractItemKey(currentItem);
        keyItem[NtapGlobalConstants.ATTR_$parent] = currentItem;

        if (this.action.$openItemType) {
          const openItemType = this.action.$openItemType;
          const openItemIdAttr = Util.getFullAttrName(
            openItemType,
            NtapGlobalConstants.ATTR_id
          );
          const oldItemType = keyItem[NtapGlobalConstants.ATTR_$itemType];
          keyItem[NtapGlobalConstants.ATTR_$parentType] = oldItemType;
          keyItem[NtapGlobalConstants.ATTR_$parentId] =
            keyItem[
              Util.getFullAttrName(oldItemType, NtapGlobalConstants.ATTR_id)
            ];
          keyItem[NtapGlobalConstants.ATTR_$itemType] = openItemType;
          keyItem[openItemIdAttr] = NtapGlobalConstants.ID_NEW;
        }

        const viewState = Object.assign({}, keyItem);

        return this.doOpenWindow(viewState).pipe(
          filter((viewResult: any) => this.acceptResult(viewResult)),
          map((viewResult: ViewResult) => {
            const actionResult: any =
              viewResult.actionResult ?? EMPTY_ACTION_RESULT;
            const resultItem =
              actionResult.$data ?? viewResult.viewData?.[0] ?? currentItem;
            if (this.itemViewProvider && resultItem) {
              const updatedItem = Object.assign({}, currentItem, resultItem);
              this.itemViewProvider.updateItem(updatedItem);
            }
            return new ItemActionResult(actionResult, resultItem);
          })
        );
      })
    );
  }

  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }

  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    return OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      OpenGeneratorUrbrojActionComponent.GENERATOR_URBROJ_VIEW_TARGET
    );
  }

  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }
}
